import * as React from 'react';
import TextInput from '@af-common/Common/_components/TextInput';
import ModuleChevronStore from '../_stores/ModuleChevronStore';
import { ColorResult } from 'react-color'
import SimplePicker from '../../../Misc/_components/SimplePicker';
import { Trans } from 'react-i18next';

export type Props = {
	moduleId?: string
	angle?: number
	thickness1?: number
	color1?: string
	color2?: string
	onAngleChange?: Function
	onThickness1Change?: Function
	onColor1Change?: (color: ColorResult) => void
	onColor2Change?: (color: ColorResult) => void
}

const T = ({children, ...otherProps}:any) => <Trans ns="create" {...otherProps}>{children}</Trans>

export default class ModuleChevronSettings extends React.Component<Props> {
	render = () => <>
		<TextInput type="number" min={0} label={<T>Angle</T>} onChange={this.props.onAngleChange} value={String(this.props.angle)}/>
		<TextInput type="number" min={0} label={<T>Thickness</T>} onChange={this.props.onThickness1Change} value={String(this.props.thickness1)}/>
		<SimplePicker onColorChange={this.props.onColor1Change} color={this.props.color1}/>
		<SimplePicker onColorChange={this.props.onColor2Change} color={this.props.color2}/>
	</>
}